module.exports = __webpack_public_path__ + "static/media/CompleteVerification.ebac3fd2.svg";